<!--
  Configuraciones de la plataforma. Cada ajuste es una fila .off-item:
  etiqueta a la izquierda y control a la derecha; los controles grandes usan
  .off-item-stacked (etiqueta arriba, controles abajo). Estilos en offsidebar.component.scss.
-->
<section class="off-section">
  <h6 class="off-section-title">{{ "alerts.actions.settings" | translate }}</h6>
  <p class="off-section-subtitle">{{ "offsidebar.configuration.subtitle" | translate }}</p>

  <ng-container *ngIf="!storageService.isAdmin() || mode === 1">
    <!-- Redistribucion -->
    <div class="off-item" *ngIf="farm && permissions.view_refeed">
      <label class="off-item-label mb-0" [for]="'use_refeeding_offsidebar_' + farm.id">
        {{ "admin.clients.client.redistribution" | translate }}
      </label>
      <div class="custom-control custom-switch">
        <input
          name="status"
          type="checkbox"
          class="custom-control-input"
          [id]="'use_refeeding_offsidebar_' + farm.id"
          [checked]="farm.use_refeeding"
          (change)="changeAutomaticTesting('use_refeeding')"
        />
        <label class="custom-control-label" [for]="'use_refeeding_offsidebar_' + farm.id"></label>
      </div>
    </div>

    <!-- Tests automaticos: hora + guardar + activar -->
    <div class="off-item off-item-stacked" *ngIf="farm && permissions.view_automatic_test">
      <div class="off-item-row">
        <label class="off-item-label mb-0" [for]="'status_test_alert'">
          {{ "offsidebar.configuration.automatic-tests" | translate }}
        </label>
        <div class="custom-control custom-switch">
          <input
            name="status"
            type="checkbox"
            class="custom-control-input"
            [id]="'status_test_alert'"
            [(ngModel)]="status_test_alert"
            (change)="changeAutomaticTesting('status_test_alert')"
          />
          <label class="custom-control-label" [for]="'status_test_alert'"></label>
        </div>
      </div>
      <!-- Hora de ejecucion: se atenua mientras los tests estan desactivados -->
      <div class="off-subitem" [class.off-dimmed]="!status_test_alert">
        <small class="off-item-hint">{{ "offsidebar.configuration.run-time" | translate }}</small>
        <div class="off-item-controls">
          <div class="time-picker">
            <ngb-timepicker
              [(ngModel)]="autimaticTestTime"
              [spinners]="false"
              ngDefaultControl
            >
            </ngb-timepicker>
          </div>
          <button
            type="button"
            class="off-icon-btn"
            [attr.aria-label]="'general.save' | translate"
            (click)="setAutomaticTime()"
          >
            <em class="fa fa-save"></em>
          </button>
        </div>
      </div>
    </div>

    <!-- Cambio de puerto -->
    <div class="off-item off-item-stacked off-item-inline" *ngIf="farm && globalFunction.validateSoloAdmin()">
      <span class="off-item-label">{{ "offsidebar.configuration.port-change" | translate }}</span>
      <select class="form-control" name="port" [(ngModel)]="port" (change)="changePort()">
        <option value="">{{ "offsidebar.configuration.select-port" | translate }}</option>
        <option *ngFor="let item of ports" [value]="item">A{{ item }}</option>
      </select>
    </div>
  </ng-container>

  <!-- DPI -->
  <div class="off-item" *ngIf="globalFunction.validateSoloAdmin() && mode === 1">
    <span class="off-item-label">DPI</span>
    <div class="off-item-controls">
      <input
        type="number"
        class="form-control off-input-sm"
        [(ngModel)]="fuzzy_dpi"
        (keyup.enter)="changeConfig('fuzzy_dpi', fuzzy_dpi)"
      />
      <button
        type="button"
        class="off-icon-btn"
        *ngIf="fuzzy_dpi !== fuzzy_dpi_saved"
        [attr.aria-label]="'general.save' | translate"
        (click)="changeConfig('fuzzy_dpi', fuzzy_dpi)"
      >
        <em class="fa fa-save"></em>
      </button>
    </div>
  </div>

  <!-- Tiempo entre reintentos -->
  <div class="off-item" *ngIf="storageService.isAdmin()">
    <div class="off-item-text">
      <span class="off-item-label">{{ "offsidebar.configuration.retry-time" | translate }}</span>
      <small class="off-item-hint">{{ "offsidebar.configuration.seconds" | translate }}</small>
    </div>
    <div class="off-item-controls">
      <div class="off-stepper">
        <button
          type="button"
          [disabled]="scheduleDurationSaving"
          [attr.aria-label]="'offsidebar.decrease' | translate"
          (click)="$event.stopPropagation(); decreaseScheduleDuration()"
        >
          <em class="fa fa-minus"></em>
        </button>
        <span class="off-stepper-value">
          {{ scheduleDuration < 10 ? '0' + scheduleDuration : scheduleDuration }}
        </span>
        <button
          type="button"
          [disabled]="scheduleDurationSaving"
          [attr.aria-label]="'offsidebar.increase' | translate"
          (click)="$event.stopPropagation(); increaseScheduleDuration()"
        >
          <em class="fa fa-plus"></em>
        </button>
      </div>
      <button
        type="button"
        class="off-icon-btn"
        [class.off-icon-btn-hidden]="scheduleDuration === scheduleDurationSaved || scheduleDurationSaving"
        [attr.aria-label]="'general.save' | translate"
        (click)="$event.stopPropagation(); saveScheduleDuration()"
      >
        <em class="fa fa-save"></em>
      </button>
    </div>
  </div>

  <!-- Envio de frames -->
  <div class="off-item off-item-stacked" *ngIf="storageService.isAdmin()">
    <span class="off-item-label">{{ "offsidebar.configuration.xbee-frames.title" | translate }}</span>

    <div class="off-subitem">
      <small class="off-item-hint">
        {{ "offsidebar.configuration.xbee-frames.frame-amount" | translate }}
      </small>
      <div class="off-item-controls">
        <div class="off-stepper">
          <button
            type="button"
            [disabled]="xbeeFrameAmountSaving"
            [attr.aria-label]="'offsidebar.decrease' | translate"
            (click)="$event.stopPropagation(); decreaseXbeeFrameAmount()"
          >
            <em class="fa fa-minus"></em>
          </button>
          <span class="off-stepper-value">{{ xbeeFrameAmount }}</span>
          <button
            type="button"
            [disabled]="xbeeFrameAmountSaving"
            [attr.aria-label]="'offsidebar.increase' | translate"
            (click)="$event.stopPropagation(); increaseXbeeFrameAmount()"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
        <button
          type="button"
          class="off-icon-btn"
          [class.off-icon-btn-hidden]="xbeeFrameAmount === xbeeFrameAmountSaved || xbeeFrameAmountSaving"
          [attr.aria-label]="'general.save' | translate"
          (click)="$event.stopPropagation(); saveXbeeFrameAmount()"
        >
          <em class="fa fa-save"></em>
        </button>
      </div>
    </div>

    <div class="off-subitem">
      <small class="off-item-hint">
        {{ "offsidebar.configuration.xbee-frames.time-between-packets" | translate }}
      </small>
      <div class="off-item-controls">
        <div class="off-stepper">
          <button
            type="button"
            [disabled]="xbeeFrameTimedeltaSaving"
            [attr.aria-label]="'offsidebar.decrease' | translate"
            (click)="$event.stopPropagation(); decreaseXbeeFrameTimedelta()"
          >
            <em class="fa fa-minus"></em>
          </button>
          <span class="off-stepper-value">{{ xbeeFrameTimedelta }}</span>
          <button
            type="button"
            [disabled]="xbeeFrameTimedeltaSaving"
            [attr.aria-label]="'offsidebar.increase' | translate"
            (click)="$event.stopPropagation(); increaseXbeeFrameTimedelta()"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
        <button
          type="button"
          class="off-icon-btn"
          [class.off-icon-btn-hidden]="xbeeFrameTimedelta === xbeeFrameTimedeltaSaved || xbeeFrameTimedeltaSaving"
          [attr.aria-label]="'general.save' | translate"
          (click)="$event.stopPropagation(); saveXbeeFrameTimedelta()"
        >
          <em class="fa fa-save"></em>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- CONFIGURACION DE GRANJA: thresholds de registro y validacion de testeo -->
<section class="off-section" *ngIf="farm && globalFunction.validateSoloAdmin()">
  <h6 class="off-section-title">
    {{ "offsidebar.configuration.farm-config.title" | translate }}
  </h6>

  <!-- Biometrias: obligatorio y frecuencia (cada valor + unidad) -->
  <div class="off-item off-item-stacked off-threshold-item">
    <div class="off-item-row">
      <label class="off-item-label mb-0" [for]="'biometry_status_' + farm.id">
        {{ "offsidebar.configuration.farm-config.biometrics" | translate }}
      </label>
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          [id]="'biometry_status_' + farm.id"
          [(ngModel)]="requiredBiometricRegistration"
        />
        <label class="custom-control-label" [for]="'biometry_status_' + farm.id"></label>
      </div>
    </div>
    <!-- Frecuencia: "Cada [valor] [unidad]"; se atenua si el registro no es obligatorio -->
    <div class="off-item-controls off-threshold" [class.off-dimmed]="!requiredBiometricRegistration">
      <small class="off-item-hint">{{ "offsidebar.configuration.farm-config.every" | translate }}</small>
      <input
        type="number"
        class="form-control off-input-sm"
        min="1"
        max="32767"
        [(ngModel)]="biometryFrequencyValue"
      />
      <select class="form-control" [(ngModel)]="biometryFrequencyUnit">
        <option [value]="1">{{ "offsidebar.configuration.farm-config.days" | translate }}</option>
        <option [value]="2">{{ "offsidebar.configuration.farm-config.weeks" | translate }}</option>
        <option [value]="3">{{ "offsidebar.configuration.farm-config.months" | translate }}</option>
      </select>
      <button
        type="button"
        class="off-icon-btn"
        [class.off-icon-btn-hidden]="!isBiometryChanged() || farmConfigSaving"
        [attr.aria-label]="'general.save' | translate"
        (click)="$event.stopPropagation(); saveBiometryThreshold()"
      >
        <em class="fa fa-save"></em>
      </button>
    </div>
  </div>

  <!-- Parametrias: obligatorio y frecuencia (cada valor + unidad) -->
  <div class="off-item off-item-stacked off-threshold-item">
    <div class="off-item-row">
      <label class="off-item-label mb-0" [for]="'parametric_status_' + farm.id">
        {{ "offsidebar.configuration.farm-config.parametrics" | translate }}
      </label>
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          [id]="'parametric_status_' + farm.id"
          [(ngModel)]="requiredParametricRegistration"
        />
        <label class="custom-control-label" [for]="'parametric_status_' + farm.id"></label>
      </div>
    </div>
    <!-- Frecuencia: "Cada [valor] [unidad]"; se atenua si el registro no es obligatorio -->
    <div class="off-item-controls off-threshold" [class.off-dimmed]="!requiredParametricRegistration">
      <small class="off-item-hint">{{ "offsidebar.configuration.farm-config.every" | translate }}</small>
      <input
        type="number"
        class="form-control off-input-sm"
        min="1"
        max="32767"
        [(ngModel)]="parametricFrequencyValue"
      />
      <select class="form-control" [(ngModel)]="parametricFrequencyUnit">
        <option [value]="1">{{ "offsidebar.configuration.farm-config.days" | translate }}</option>
        <option [value]="2">{{ "offsidebar.configuration.farm-config.weeks" | translate }}</option>
        <option [value]="3">{{ "offsidebar.configuration.farm-config.months" | translate }}</option>
      </select>
      <button
        type="button"
        class="off-icon-btn"
        [class.off-icon-btn-hidden]="!isParametricChanged() || farmConfigSaving"
        [attr.aria-label]="'general.save' | translate"
        (click)="$event.stopPropagation(); saveParametricThreshold()"
      >
        <em class="fa fa-save"></em>
      </button>
    </div>
  </div>

  <!-- Validacion de testeo de estanque para alimentar -->
  <div class="off-item">
    <label class="off-item-label mb-0" [for]="'required_pond_testing_' + farm.id">
      {{ "offsidebar.configuration.farm-config.required-pond-testing" | translate }}
    </label>
    <div class="custom-control custom-switch">
      <input
        name="required_pond_testing"
        type="checkbox"
        class="custom-control-input"
        [id]="'required_pond_testing_' + farm.id"
        [checked]="storageService.localValue.required_pond_testing"
        (change)="changeRequiredPondTesting()"
      />
      <label class="custom-control-label" [for]="'required_pond_testing_' + farm.id"></label>
    </div>
  </div>
</section>
